<template>
    <div class="container">
        <div class="header">
            <img src="@/assets/mbImg/fh.png" alt="" @click="goBack">
            <div>免费试用</div>
            <div></div>
        </div>
        <div class="main">
            <div class="content">
                <van-form>
                    <van-field name="type" label="类型">
                        <template #input>
                            <div class="type">
                                <div :class="item.active?'active':''" v-for="(item,index) in tableList" :key="index" @click="handleChange(index)">{{ item.label }}</div>
                            </div>
                        </template>
                    </van-field>
                    <van-field name="area" label="城市" @click="showArea = true">
                        <template #input>
                            <div class="select">
                                <span>{{ formData.city || '请选择'}}</span>
                                <img src="@/assets/mbImg/gd2.png">
                            </div>
                        </template>
                    </van-field>
                    <template v-if="formData.type == 1">
                        <van-field
                            v-model="formData.username"
                            name="username"
                            label="公司全称"
                            placeholder="请输入"
                        />
                        <van-field
                            v-model="formData.username2"
                            name="username2"
                            label="公寓名称"
                            placeholder="请输入"
                        />
                        <van-field
                            v-model="formData.username2"
                            name="username2"
                            label="营业执照编号"
                            placeholder="请输入"
                        />
                    </template>
                    <van-field name="type" label="业务类型" @click="showPicker = true">
                        <template #input>
                            <div class="select">
                                <span>{{ formData.type || '请选择'}}</span>
                                <img src="@/assets/mbImg/gd2.png">
                            </div>
                        </template>
                    </van-field>
                    <van-field
                        v-model="formData.username2"
                        name="username2"
                        label="房源数量"
                        placeholder="请输入"
                    />
                </van-form>
            </div>
            <div class="content">
                <van-form>
                    <van-field
                        v-model="formData.username"
                        name="username"
                        label="法人姓名"
                        placeholder="请输入"
                    />
                    <van-field
                        v-model="formData.username"
                        name="username"
                        label="手机号码"
                        placeholder="请输入"
                    />
                    <van-field name="type" label="验证码">
                        <template #input>
                            <div class="select yzm">
                                <van-field :border="false" v-model="formData.username" label="" placeholder="请输入" />
                                <van-button type="info" size="small" :round="true" :color="isBegin?'#DDDDDD':'#2870FF'" @click="handleGetCode">{{ isBegin?`${second}s`:'获取验证码' }}</van-button>
                            </div>
                        </template>
                    </van-field>
                </van-form>
            </div>

            <!-- 遮罩层 -->
            <van-overlay :show="showMask" @click="showMask = false">
                <div class="mask" @click.stop>
                    <div class="tip">
                        <div class="title">提交成功</div>
                        <div class="context">稍后工作人员将会与您联系， 请保持电话畅通,祝您生活愉快！</div>
                        <van-button type="info" :round="true" color="#2870FF" @click="showMask = false" size="32">确定</van-button>
                    </div>
                </div>
            </van-overlay>
            <!-- 地区选择 -->
            <van-popup v-model="showArea" position="bottom">
                <van-area
                    :area-list="areaList"
                    @confirm="onConfirmArea"
                    @cancel="showArea = false"
                />
            </van-popup>
            <!-- 选择器 -->
            <van-popup v-model="showPicker" position="bottom">
                <van-picker
                    show-toolbar
                    :columns="columns"
                    @confirm="onConfirmPick"
                    @cancel="showPicker = false"
                />
            </van-popup>
        </div>
        <div class="footer">
            <van-button type="info" :round="true" color="#2870FF" @click="handleSunmit" size="32">提交</van-button>
        </div>
    </div>
</template>
<script>
    import { areaList } from '@vant/area-data';
    export default {
        data() {
            return {
                formData: {
                    type: 1,
                    city: null,
                    username: null,
                    username2: null
                },
                tableList: [
                    { label: '公寓企业', value: 1,active: true },
                    { label: '个人房东', value: 2,active: false }
                ],
                showArea: false,
                areaList,
                showPicker: false,
                columns: ['杭州', '宁波', '温州', '嘉兴', '湖州'],
                second: 60,
                isBegin: false,
                timer: null,
                showMask: false
            }
        },
        methods: {
            goBack() {
                this.$router.go(-1)
            },
            handleChange(index) {
                this.tableList.forEach((item,i) => {
                    if(index == i) {
                        item.active = true
                        this.formData.type = item.value
                    }else {
                        item.active = false
                    }
                })
            },
            onConfirmArea(e) {
                this.formData.city = `${e[0].name} - ${e[1].name} - ${e[2].name}`
                this.showArea = false
            },
            onConfirmPick(e) {
                this.showPicker = false
            },
            handleGetCode() {
                if(this.isBegin) return
                this.isBegin = true
                this.timer = setInterval(() => {
                    this.second = this.second - 1
                    if(this.second <= 0) {
                        this.isBegin = false
                        this.second = 60
                        clearInterval(this.timer)
                    }
                },1000)
            },
            handleSunmit() {
                this.showMask = true
            }
        }
    }
</script>
<style scoped lang="scss">
.container {
    width: 100%;
    height: auto;
    .header {
        width: 100%;
        height: 90px;
        background: #fff;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 20px;
        box-sizing: border-box;
        position: fixed;
        top: 0;
        left: 0;
        img {
            width: 44px;
            height: 44px;
        }
    }
    .main {
        width: 100%;
        height: 100vh;
        padding: 110px 30px 130px 30px;
        box-sizing: border-box;
        background: #f5f5f5;
        .content {
            width: 100%;
            background: #fff;
            border-radius: 20px;
            padding: 8px 0;
            box-sizing: border-box;
            margin-bottom: 20px;
            ::v-deep .van-field__body {
                display: flex;
                justify-content: flex-end!important;
            }
            ::v-deep .van-field__control {
                width: 100%;
                display: flex;
                justify-content: flex-end;
                text-align: right;
            }
            ::v-deep .van-cell__title {
                display: flex;
                align-items: center;
            }
            .type {
                display: flex;
                align-items: center;
                column-gap: 24px;
                div {
                    width: 160px;
                    height: 52px;
                    border-radius: 26px;
                    border: 1px solid #EEEEEE;
                    background: #FFFFFF;
                    font-size: 28px;
                    color: #999999;
                    text-align: center;
                    line-height: 52px;
                    transition: 0.3s ease all;
                }
                .active {
                    background: #2870FF;
                    color: #fff;
                    border: 1px solid #2870FF;
                }
            }
            .select {
                display: flex;
                align-items: center;
                column-gap: 8px;
                color: #999999;
                img {
                    width: 28px;
                    height: 28px;
                }
            }
            .yzm {
                ::v-deep .van-button {
                    width: 240px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
            }
        }
        .mask {
            display: flex;
            justify-content: center;
            .tip {
                width: 540px;
                height: 338px;
                background: #FFFFFF;
                border-radius: 20px;
                padding: 40px 0;
                box-sizing: border-box;
                margin-top: 60%;
                display: flex;
                flex-direction: column;
                align-items: center;
                row-gap: 30px;
                .title {
                    color: #333333;
                    font-size: 32px;
                    font-weight: bold;
                }
                .context {
                    font-size: 28px;
                    color: #666666;
                    width: 400px;
                }
                ::v-deep .van-button {
                    width: 300px;
                }
            }
        }
    }
    .footer {
        width: 100%;
        height: 110px;
        background: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        position: fixed;
        bottom: 0;
        left: 0;
        padding: 0 30px;
        box-sizing: border-box;
        ::v-deep .van-button {
            width: 100%;
        }
    }
}
</style>